import React, { useEffect, useRef, useState } from "react";
import Icon from "../Icon/Icon.tsx";
import Tooltip from "../Tooltip/Tooltip.js";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";
import { searchKeyInObject } from "../../Reusable/Form/Form.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import useOnClickOutside from "../../../hooks/useOnClickOutside.js";

import "./Field.scss";

const SelectElement = ({
  item,
  register,
  setValue,
  getValues,
  errors,
  clearErrors,
  props,
  defaultSelect,
}) => {
  const { getTextByKey } = useContent();
  const [title, setTitle] = useState(item.label);
  const [showList, setShowList] = useState(false);

  const handleChange = (selectItem) => {
    setShowList(false);
    setValue(item.fieldKey, selectItem.value);
    errors[item.fieldKey] && clearErrors([item.fieldKey]);
  };

  useEffect(() => {
    getValues()[item.fieldKey] &&
      setTitle(searchKeyInObject(item.selectList, getValues()[item.fieldKey]));
  }, [getValues()[item.fieldKey]]);

  const ref = useRef();
  useOnClickOutside(ref, () => setShowList(false));

  useEffect(() => {
    if (defaultSelect) {
      setTimeout(() => {
        handleChange(defaultSelect);
      }, 100);
    }
    register(item.fieldKey, {
      required: item.validation?.required,
    });
  }, []);

  return (
    <>
      <div className={`select-outside-label ${props.label}`}>
        {getTextByKey(item.label)}
      </div>
      <div
        className={`select-container ${
          errors[item.fieldKey] ? "invalid-input" : ""
        }`}
        name={item.fieldKey}
        ref={ref}
      >
        <div
          className={`select-label`}
          onClick={() => setShowList((prev) => !prev)}
        >
          {getTextByKey(title)}
          <Tooltip
            id={item.title}
            tooltipTextKey={item.tooltip ? item.tooltip.text : null}
            top
          >
            <div className={`tootltip-icon-container`}>
              <Icon white medium name="arrow-down" />
            </div>
          </Tooltip>
        </div>

        <AnimationContainer animationOn={showList} animationClassName="fade-in">
          <div className={"selectlist-container"}>
            {item.selectList.map((selectItem) => (
              <div
                className="selectlist-item"
                onClick={() => handleChange(selectItem)}
                key={selectItem.constKey}
              >
                {getTextByKey(selectItem.constKey)}
              </div>
            ))}
          </div>
        </AnimationContainer>
      </div>
    </>
  );
};

export default SelectElement;
